import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import {
  brandColours,
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
} from '../styles';
import { Container, Heading, Button } from './ui';
import ReviewCard from './ReviewCard';

const StyledFeaturedReviews = styled.section`
  ${sectionPaddings()};
  background-color: ${brandColours.quaternary};
`;

const StyledHeading = styled(Heading)`
  text-align: center;
  color: ${standardColours.white};
`;

const StyledItems = styled.div`
  display: grid;
  gap: 30px 20px;
  margin-top: 40px;

  ${minBreakpointQuery.small`
    margin-top: 45px;
  `}

  ${minBreakpointQuery.smedium`
    margin-top: 50px;
  `}

  ${minBreakpointQuery.medium`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${minBreakpointQuery.large`
    margin-top: 55px;
  `}

  ${minBreakpointQuery.xxlarge`
    margin-top: 60px;
  `}
`;

const StyledButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const StyledButton = styled(Button)`
  margin-top: 30px;

  ${minBreakpointQuery.small`
    margin-top: 35px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 40px;
  `}
`;

const FeaturedReviews = ({ heading, initialItems, link }) => {
  const {
    allDatoCmsReview: { nodes },
  } = useStaticQuery(graphql`
    query FeaturedReviewsQuery {
      allDatoCmsReview(sort: { meta: { firstPublishedAt: DESC } }, limit: 3) {
        nodes {
          ...ReviewCardFragment
        }
      }
    }
  `);

  const items = initialItems && initialItems.length > 0 ? initialItems : nodes;

  return (
    <StyledFeaturedReviews>
      <Container>
        <StyledHeading>{heading}</StyledHeading>
        {items.length > 0 && (
          <StyledItems>
            {items.map(({ title, review, authorRole, companyLocation }, id) => (
              <ReviewCard
                key={id}
                title={title}
                review={review}
                authorRole={authorRole}
                companyLocation={companyLocation}
              />
            ))}
          </StyledItems>
        )}
        {link && (
          <StyledButtonWrapper>
            <StyledButton to={link.pageUrl}>{link.text}</StyledButton>
          </StyledButtonWrapper>
        )}
      </Container>
    </StyledFeaturedReviews>
  );
};

export default FeaturedReviews;
